module.exports = __webpack_public_path__ + "static/media/crash-808.de6f53e5.wav";